import http from './http';

export default {
  all(data) {
    return http().post('/v1/contacts-collection', data);
  },
  get(id) {
    return http().get(`/v1/contacts/${id}`);
  },
  search(query = '') {
    return http().get(`/v1/contacts/search?${query}`);
  },
  getProcessedMassActions(query) {
    return http().get(`v1/contacts/processed-actions?` + query)
  },
  create(data) {
    return http().post(`/v1/contacts`, data);
  },
  update(data) {
    return http().put(`/v1/contacts/${data.id}`, data);
  },
  attachRecord(data) {
    return http().put(`/v1/contacts/${data.id}/attach_record`, data)
  },
  attachCustomFields(data) {
    return http().put(`/v1/contacts/${data.id}/custom_fields`, data);
  },
  attachContactTypes(data) {
    return http().put(`/v1/contacts/${data.id}/contact_types`, data);
  },
  attachTags(data) {
    return http().put(`/v1/contacts/${data.id}/tags`, data);
  },
  setPrimaryRecord(data) {
    // TODO pipeline-overhaul josh data should be { id: contactId, primary_record_id: recordId }
    return http().put(`/v1/contacts/${data.id}/set-primary-record`, data);
  },
  bulkUpdateContactTypes(data) {
    return http().put(`/v1/contacts/bulk-contact-types`, data);
  },
  bulkUpdateTags(data) {
    return http().put(`/v1/contacts/bulk-tags`, data);
  },
  delete(id) {
    return http().delete(`/v1/contacts/${id}`);
  },

  /**
   * LEAD/CONTACT DUPLICATE ROUTES
   */
  mergeDuplicate(data) {
    return http().put('/v1/contacts/merge-duplicate-contacts', data)
  },
  markNotDuplicate(primaryRecordId, duplicateRecordId) {
    return http().put('/v1/contacts/not-duplicate', {
      primary_record_id: primaryRecordId,
      duplicate_record_id: duplicateRecordId
    });
  },

}
